import { render, staticRenderFns } from "./AppSignUp.vue?vue&type=template&id=0a622d91&scoped=true&"
import script from "./AppSignUp.vue?vue&type=script&lang=js&"
export * from "./AppSignUp.vue?vue&type=script&lang=js&"
import style0 from "./AppSignUp.vue?vue&type=style&index=0&id=0a622d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a622d91",
  null
  
)

export default component.exports